import dayjs from "dayjs";
import ToastMessage from "@/components/common/toast.vue";
import Modal from "@/components/common/BottomModal/layout.vue";
import AddressResultList from "./AddressResultList.vue";
import detailForm from "./detailForm.vue";
import searchResultList from "./searchResultList.vue";
import commonPopup from "@/components/modal/commonPopup/layout.vue";
import searchTap from "./searchTab/layout.vue";
import bookmarkTap from "./bookmarkTab/layout.vue";
import recentTap from "./recentTab/layout.vue";

export default {
  components: {
    Modal,
    AddressResultList,
    ToastMessage,
    detailForm,
    searchResultList,
    commonPopup,
    searchTap,
    bookmarkTap,
    recentTap,
  },
  props: ["pinStatus"],
  data() {
    return {
      isPopupOpen: false, // 기본적인 공통 팝업 제어
      isDeletePin: false, // confirm 반환받는 공통 팝업 제어
      popupMsg: "",
      confirmMsg: "",
      query: "",
      code: null,

      deletePin: null,

      toastList: [],
      isToastOpen: false,
      searchStatus: "none", //none, loading, init

      selectAddress: {}, //선택한 주소
      modalType: "search", // search, bookmark, recent, detail

      bookmarkAddressList: [], // 즐겨찾기 저장된 주소
      recentAddressList: [], // 최근사용 주소
      subAddressList: [], // 즐겨찾기 저장된 주소 3개 + 최근사용주소
      searchAddressList: [], //검색결과 주소
    };
  },
  created() {
    document.body.classList.add("modal-open");
    this.pinStatus === "departure" ? (this.code = 1) : (this.code = 2);
    this.getList();
  },
  destroyed() {
    document.body.classList.remove("modal-open");
  },
  computed: {
    addressList() {
      const type = this.modalType;
      if (type === "bookmark") {
        return this.bookmarkAddressList;
      } else if (type === "recent") {
        return this.recentAddressList;
      } else if (type === "search") {
        return this.subAddressList;
      }
    },
  },
  methods: {
    handleTap(type) {
      if (this.modalType === type) return;
      this.searchStatus = "none";
      this.searchAddressList = [];
      this.query = "";
      this.modalType = type;
    },
    handleConfirmModal(msg) {
      this.confirmMsg = msg;
      this.isDeletePin = true;
    },
    confirm() {
      this.deleteAddress(this.deletePin);
    },
    getList() {
      this.subAddressList = [];
      this.getBookmarkList();
      this.getRecentAddressList();
      this.getRecentAddressListAll();
    },

    submit(address) {
      this.$emit("selectAddress", address);
    },
    select(list) {
      this.selectAddress = list;
      this.modalType = "detail";
    },
    async getRecentAddressList() {
      const payload = {
        all: true,
        keyword: "",
      };
      let addrResult = [];
      if (this.code === 1) {
        //출발지선택
        addrResult = await this.$store.dispatch(
          "users/getRecentAddressFrom",
          payload
        );
      } else {
        //도착/경유지 선택
        addrResult = await this.$store.dispatch(
          "users/getRecentAddressTo",
          payload
        );
      }

      this.recentAddressList = _.cloneDeep(addrResult.data);
    },
    async getRecentAddressListAll() {
      const payload = {
        all: false,
        keyword: "",
      };
      let addrResult = [];
      if (this.code === 1) {
        //출발지선택
        addrResult = await this.$store.dispatch(
          "users/getRecentAddressFrom",
          payload
        );
      } else {
        //도착/경유지 선택
        addrResult = await this.$store.dispatch(
          "users/getRecentAddressTo",
          payload
        );
      }

      this.subAddressList = this.subAddressList.concat(addrResult.data);
    },
    async getBookmarkList() {
      const payload = {
        code: this.code,
        keyword: "",
      };
      const result = await this.$store.dispatch(
        "users/getBookmarkAddress",
        payload
      );

      if (result.success) {
        this.bookmarkAddressList = _.cloneDeep(result.bookmarkAddress);
        this.bookmarkAddressList.map((element) => {
          element.isBookmark = true;
        });
      } else {
        return this.controlPopup("주소정보를 불러오는데 실패하였습니다.");
      }

      for (
        let i = Math.min(3, this.bookmarkAddressList.length) - 1;
        i >= 0;
        i--
      ) {
        this.subAddressList.unshift(this.bookmarkAddressList[i]);
      }
    },
    getLongNameByType(list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].types.includes("DONGMYUN")) {
          return list[i].longName;
        }
      }
      return null;
    },
    addBookmark(pin) {
      const payload = {
        name: pin.name,
        phoneNumber: pin.phoneNumber,
        jibunAddress: pin.jibunAddress,
        roadAddress:
          pin.roadAddress !== "" ? pin.roadAddress : pin.jibunAddress,
        detailAddress: pin.detailAddress,
        dongName: pin.dongName ?? this.getLongNameByType(pin.addressElements),
        pinMemo: pin.pinMemo ?? "",
        coords: [parseFloat(pin.coords[0]), parseFloat(pin.coords[1])],
        addressElements: pin.addressElements,
        code: this.code,
        recentAddressId: pin._id,
      };

      this.$store
        .dispatch("users/appendBookmarkAddress", payload)
        .then((result) => {
          if (this.modalType === "recent" && this.searchStatus === "init") {
            this.searchRecentAddress(this.query);
          }
          this.getList();
          this.toast("즐겨찾기에 추가되었습니다.");
        })
        .catch((e) => {
          this.getList();
          this.controlPopup("주소추가에 실패하였습니다");
        });
    },
    clickDelete(list) {
      this.handleConfirmModal("즐겨찾기에서 삭제하시겠습니까?");
      this.deletePin = list;
    },
    deleteAddress(list) {
      const bookmarkId = list.bookmarkId ? list.bookmarkId : list._id;

      const result = this.$store
        .dispatch("users/biz_delete_bookmark", { bookmarkId: bookmarkId })
        .then((result) => {
          if (!result.success) {
            this.controlPopup("에러가 발생하였습니다");
          } else {
            this.toast(
              `즐겨찾기에서 삭제되었습니다.<br/>최근배송 목록에서 확인하실 수 있어요.`
            );
          }
          if (this.searchStatus === "init") {
            if (this.modalType === "bookmark") {
              this.searchBookmark(this.query);
            }
            if (this.modalType === "recent") {
              this.searchRecentAddress(this.query);
            }
          }
          this.getList();
        })
        .catch((e) => {
          console.error(e);
          this.getList();
          this.controlPopup("에러가 발생하였습니다");
        });
    },
    toast(msg) {
      this.toastList.push({
        msg: msg,
        date: dayjs().valueOf(),
      });

      setTimeout(() => {
        this.toastList.shift();
      }, 3000);
    },

    controlPopup(msg) {
      this.isPopupOpen = true;
      this.popupMsg = msg;
    },

    async searchAddress(query) {
      this.query = query;
      if (!this.query) {
        return (this.searchStatus = "none");
      }
      this.searchStatus = "loading";

      const searchResult = await this.$store.dispatch(
        "search_address",
        this.query
      );

      this.searchAddressList = []; // 이전에 불러온 데이터 초기화
      if (searchResult.serverError === true) {
        this.searchStatus = "none";
        this.query = "";
        return this.$emit("controlPopup", "서버에러가 발생하였습니다.");
      } else if (searchResult.length === 0) {
        this.searchStatus = "init";
        this.searchAddressList = searchResult;
        return;
      }

      this.searchAddressList = _.cloneDeep(searchResult);
      this.searchStatus = "init";
    },
    async searchBookmark(query) {
      this.query = query;
      if (!this.query) {
        return (this.searchStatus = "none");
      }
      this.searchStatus = "loading";
      const payload = {
        code: this.code,
        keyword: this.query,
      };

      const result = await this.$store.dispatch(
        "users/getBookmarkAddress",
        payload
      );

      this.searchAddressList = []; // 이전에 불러온 데이터 초기화
      if (!result.success) {
        this.searchStatus = "none";
        this.$emit("controlPopup", "주소정보를 불러오는데 실패하였습니다.");
      } else if (result.bookmarkAddress === 0) {
        this.searchStatus = "init";
        return;
      }

      result.bookmarkAddress.map((element) => {
        element.isBookmark = true;
      });
      this.searchAddressList = _.cloneDeep(result.bookmarkAddress);
      this.searchStatus = "init";
    },
    async searchRecentAddress(query) {
      this.query = query;
      if (!this.query) {
        return (this.searchStatus = "none");
      }
      this.searchStatus = "loading";
      const payload = {
        all: true,
        keyword: this.query,
      };

      let addrResult = [];
      if (this.code === 1) {
        //출발지선택
        addrResult = await this.$store.dispatch(
          "users/getRecentAddressFrom",
          payload
        );
      } else {
        //도착/경유지 선택
        addrResult = await this.$store.dispatch(
          "users/getRecentAddressTo",
          payload
        );
      }

      this.searchAddressList = []; // 이전에 불러온 데이터 초기화
      if (!addrResult.success) {
        this.searchStatus = "none";
        this.query = "";
        this.$emit("controlPopup", "주소정보를 불러오는데 실패하였습니다.");
      } else if (addrResult.data.length === 0) {
        this.searchStatus = "init";
        this.searchAddressList = _.cloneDeep(addrResult.data);
        return;
      }
      this.searchAddressList = _.cloneDeep(addrResult.data);
      this.searchStatus = "init";
    },
  },
};
